import * as THREE from 'three';

const FADE_MS = 400;
const MUZZLE_MS = 80;

/** Brief gold kill-cam line from shooter camera to elimination point. */
export class FpsKillTracer {
  private tracerMesh: THREE.Mesh | null = null;
  private tracerMat: THREE.MeshBasicMaterial | null = null;
  private tracerGeo: THREE.BufferGeometry | null = null;
  private muzzleMesh: THREE.Mesh | null = null;
  private muzzleMat: THREE.MeshBasicMaterial | null = null;
  private muzzleGeo: THREE.BufferGeometry | null = null;
  private fadeStart = 0;
  private muzzleStart = 0;
  private active = false;

  spawn(scene: THREE.Scene, from: THREE.Vector3, to: THREE.Vector3): void {
    this.dispose();
    const dir = to.clone().sub(from);
    const len = dir.length();
    if (len < 0.05) return;

    this.tracerGeo = new THREE.CylinderGeometry(0.028, 0.028, len, 6);
    this.tracerMat = new THREE.MeshBasicMaterial({
      color: 0xfff0aa,
      transparent: true,
      opacity: 1,
      blending: THREE.AdditiveBlending,
      depthWrite: false,
    });
    this.tracerMesh = new THREE.Mesh(this.tracerGeo, this.tracerMat);
    const mid = from.clone().add(to).multiplyScalar(0.5);
    this.tracerMesh.position.copy(mid);
    this.tracerMesh.lookAt(to);
    this.tracerMesh.rotateX(Math.PI / 2);
    scene.add(this.tracerMesh);

    this.muzzleGeo = new THREE.SphereGeometry(0.09, 8, 8);
    this.muzzleMat = new THREE.MeshBasicMaterial({
      color: 0xffffcc,
      transparent: true,
      opacity: 1,
      blending: THREE.AdditiveBlending,
      depthWrite: false,
    });
    this.muzzleMesh = new THREE.Mesh(this.muzzleGeo, this.muzzleMat);
    this.muzzleMesh.position.copy(from);
    scene.add(this.muzzleMesh);

    const now = performance.now();
    this.fadeStart = now;
    this.muzzleStart = now;
    this.active = true;
  }

  update(): void {
    if (!this.active) return;
    const now = performance.now();

    if (this.tracerMat) {
      const t = (now - this.fadeStart) / FADE_MS;
      this.tracerMat.opacity = Math.max(0, 1 - t);
    }

    if (this.muzzleMat && this.muzzleMesh) {
      const mt = (now - this.muzzleStart) / MUZZLE_MS;
      this.muzzleMat.opacity = Math.max(0, 1 - mt);
      const scale = 1 + mt * 0.6;
      this.muzzleMesh.scale.setScalar(scale);
    }
  }

  dispose(): void {
    this.tracerMesh?.removeFromParent();
    this.tracerMesh = null;
    this.tracerGeo?.dispose();
    this.tracerGeo = null;
    this.tracerMat?.dispose();
    this.tracerMat = null;

    this.muzzleMesh?.removeFromParent();
    this.muzzleMesh = null;
    this.muzzleGeo?.dispose();
    this.muzzleGeo = null;
    this.muzzleMat?.dispose();
    this.muzzleMat = null;

    this.active = false;
  }
}
